export const routes = [
  {
    key: 1,
    name: "Air quality and impacts",
    path: "/air-quality",
    icon: "air",
  },
  {
    key: 2,
    name: "Emissions",
    path: "/emissions",
    icon: "emissions",
  },
  {
    key: 3,
    name: "Emission factor",
    path: "/emission-factor",
    icon: "factor",
  },
  {
    key: 4,
    name: "Activity data",
    path: "/activity",
    icon: "activity",
  },
  {
    key: 5,
    name: "Data management",
    path: "/data-management",
    icon: "chart",
  },
  {
    key: 6,
    name: "Scenario management",
    path: "/scenario",
    icon: "category",
    children: [
      {
        key:1,
        name:"Scenario",
        path:"/scenario"
      },
      {
        key: 2,
        name: "View structure of emission scenarios",
        path: "/scenario/view",
      },
    ],
  },
  {
    key: 7,
    name: "User  Management",
    path: "/users",
    icon: "two-user",
  },
];
